import { STATES } from "../constants/states";
import { SUPPORT_EMAIL, SUPPORT_NUMBER } from "../constants/aptihealth";

export const INITIAL_VALUES = {
  address: {
    city: "",
    state: "",
    street: "",
    zip_code: "",
  },
  dob: "",
  email: "",
  emergency_contact_no: "",
  emergency_name: "",
  first_name: "",
  gender: "Male",
  last_name: "",
  mobile: "",
};

export const CONTACT_INFO_INITIAL_VALUES = {
  dob: "",
  email: "",
  first_name: "",
  gender: "Male",
  last_name: "",
  mobile: "",
};

export const ADDRESS_INITIAL_VALUES = {
  address: {
    city: "",
    state: "",
    street: "",
    zip_code: "",
  },
};

export const EMERGENCY_CONTACT_INITIAL_VALUES = {
  emergency_contact_no: "",
  emergency_name: "",
};

export const BASIC_CONTACT_INFO_SCHEMA = [
  {
    elementConfig: {
      label: "First Name",
      placeholder: "First name",
      type: "text",
    },
    elementType: "input",
    name: "first_name",
  },
  {
    elementConfig: {
      label: "Last Name",
      placeholder: "Last name",
      type: "text",
    },
    elementType: "input",
    name: "last_name",
  },
  {
    elementConfig: {
      label: "Date of Birth",
      placeholder: "MM/DD/YYYY",
      type: "text",
    },
    elementType: "input",
    name: "dob",
  },
  {
    elementConfig: {
      label: "Gender",
      options: [
        { display: "Male", value: "male" },
        { display: "Female", value: "female" },
      ],
      placeholder: "Gender",
    },
    elementType: "select",
    name: "gender",
  },
  {
    elementConfig: {
      label: "Mobile",
      placeholder: "Mobile",
      type: "text",
    },
    elementType: "input",
    name: "mobile",
  },
  {
    elementConfig: {
      label: "Email",
      placeholder: "Email",
      type: "email",
    },
    elementType: "input",
    name: "email",
  },
];

export const CHILD_ADDRESS_AUTOFILL = [
  {
    elementConfig: {
      classNames: "font-gray",
      displayName: "Check this box if your child's address is the same as yours",
      type: "checkbox",
    },
    elementType: "input",
    name: "child_address_autofill",
    onClick: true,
  },
];

export const DEFAULT_CHILD_PRACTICE_AUTOFILL = [
  {
    elementConfig: {
      classNames: "font-gray",
      displayName: "Child has a different Primary Care Physician than above",
      type: "checkbox",
    },
    elementType: "input",
    name: "default_child_practice_autofill",
    onClick: true,
  },
];

export const CHILD_SMS_CONSENT = [
  {
    elementConfig: {
      classNames: "fs-14 font-gray",
      displayName: `I consent by electronic signature to receive calls, text messages (including SMS and MMS messages), and other electronic messages (including those made using an automatic telephone dialing system or an artificial or prerecorded voice) from aptihealth, healthcare providers with whom I am matched by aptihealth, or any of their agents or representatives at the phone number I have provided even if that number is registered on a corporate, state, or national do not call registry. I understand that my consent to such calls and messages is not required to use aptihealth’s services and that I may contact aptihealth at ${SUPPORT_EMAIL} or ${SUPPORT_NUMBER} about its services at any time. I also understand that I may revoke my consent at any time.`,
      type: "checkbox",
    },
    elementType: "input",
    name: "child_sms_consent",
    onClick: true,
  },
];

export const BASIC_ADDRESS_SCHEMA = [
  {
    elementConfig: {
      label: "Street",
      placeholder: "Enter Street",
      type: "text",
    },
    elementType: "input",
    name: "address.street",
  },
  {
    elementConfig: {
      label: "City",
      placeholder: "Enter City",
      type: "text",
    },
    elementType: "input",
    name: "address.city",
  },
  {
    elementConfig: {
      label: "State",
      options: STATES,
      placeholder: "Enter State",
    },
    elementType: "select",
    name: "address.state",
  },
  {
    elementConfig: {
      label: "Zip",
      placeholder: "Enter zip",
      type: "text",
    },
    elementType: "input",
    name: "address.zip_code",
  },
];

export const BASIC_EMERGENCY_CONTACT_SCHEMA = [
  {
    elementConfig: {
      label: "Emergency contact person",
      placeholder: "Emergency contact person",
      type: "text",
    },
    elementType: "input",
    name: "emergency_name",
  },
  {
    elementConfig: {
      label: "Emergency contact number",
      placeholder: "Emergency contact number",
      type: "text",
    },
    elementType: "input",
    name: "emergency_contact_no",
  },
];

export const BASIC_SCHEMA = [
  {
    elementConfig: {
      label: "First Name",
      placeholder: "First name",
      type: "text",
    },
    elementType: "input",
    name: "first_name",
  },
  {
    elementConfig: {
      label: "Last Name",
      placeholder: "Last name",
      type: "text",
    },
    elementType: "input",
    name: "last_name",
  },
  {
    elementConfig: {
      label: "Date of Birth",
      placeholder: "MM/DD/YYYY",
      type: "text",
    },
    elementType: "input",
    name: "dob",
  },
  {
    elementConfig: {
      label: "Gender",
      options: [
        { display: "Male", value: "male" },
        { display: "Female", value: "female" },
      ],
      placeholder: "Gender",
    },
    elementType: "select",
    name: "gender",
  },
  {
    elementConfig: {
      label: "Mobile",
      placeholder: "Mobile",
      type: "text",
    },
    elementType: "input",
    name: "mobile",
  },
  {
    elementConfig: {
      label: "Email",
      placeholder: "Email",
      type: "email",
    },
    elementType: "input",
    name: "email",
  },
  // below object does not render form element
  // only marks the hook for nested form and displays heading
  {
    displayName: "Address",
    elementType: "segment",
  },
  {
    elementConfig: {
      label: "Street",
      placeholder: "Enter Street",
      type: "text",
    },
    elementType: "input",
    name: "address.street",
  },
  {
    elementConfig: {
      label: "City",
      placeholder: "Enter City",
      type: "text",
    },
    elementType: "input",
    name: "address.city",
  },
  {
    elementConfig: {
      label: "State",
      options: STATES,
      placeholder: "Enter State",
    },
    elementType: "select",
    name: "address.state",
  },
  {
    elementConfig: {
      label: "Zip",
      placeholder: "Enter zip",
      type: "text",
    },
    elementType: "input",
    name: "address.zip_code",
  },
  {
    elementConfig: {
      label: "Emergency contact person",
      placeholder: "Emergency contact person",
      type: "text",
    },
    elementType: "input",
    name: "emergency_name",
  },
  {
    elementConfig: {
      label: "Emergency contact number",
      placeholder: "Emergency contact number",
      type: "text",
    },
    elementType: "input",
    name: "emergency_contact_no",
  },
];

export const PRI_INSURANCE_SCHEMA = [
  // below object does not render form element
  // only marks the hook for nested form and displays heading
  // {
  //     elementType: 'segment',
  //     displayName: 'Primary Insurance (Optional)'
  // },
  // {
  //     name: 'insurance[0].form.state',
  //     elementType: 'select',
  //     elementConfig: {
  //         options: [],
  //         label: 'State',
  //         placeholder: 'Select State'
  //     }
  // },
  // {
  //     name: 'insurance[0].form.carrier',
  //     elementType: 'select',
  //     elementConfig: {
  //         options: [],
  //         label: 'Carrier',
  //         placeholder: 'Select Carrier'
  //     }
  // },
  // // {
  // //     name: 'insurance[0].form.plan_type',
  // //     elementType: 'select',
  // //     elementConfig: {
  // //         options: [{ value: 'one', display: 'One' },
  // //         { value: 'two', display: 'Two' },
  // //         ],
  // //         label: 'Plan type',
  // //         placeholder: 'Select Plan type'
  // //     }
  // // },
  // {
  //     name: 'insurance[0].form.member_id',
  //     elementType: 'input',
  //     elementConfig: {
  //         type: 'text',
  //         label: 'Member ID',
  //         placeholder: 'Enter Member ID'
  //     }
  // },
];

export const SEC_INSURANCE_SCHEMA = [
  // below object does not render form element
  // only marks the hook for nested form and displays heading
  // {
  //     elementType: 'actionSegment',
  //     action: {
  //         handler: (cb) => { cb() },
  //         name: 'Remove',
  //         style: 'Btn Btn--clr-err p-0'
  //     },
  //     displayName: 'Secondary Insurance'
  // },
  // {
  //     name: 'insurance[1].form.state',
  //     elementType: 'select',
  //     elementConfig: {
  //         options: [],
  //         label: 'State',
  //         placeholder: 'Select State'
  //     }
  // },
  // {
  //     name: 'insurance[1].form.carrier',
  //     elementType: 'select',
  //     elementConfig: {
  //         options: [],
  //         label: 'Carrier',
  //         placeholder: 'Select Carrier'
  //     }
  // },
  // // {
  // //     name: 'insurance[1].form.plan_type',
  // //     elementType: 'select',
  // //     elementConfig: {
  // //         options: [{ value: 'one', display: 'One' },
  // //         { value: 'two', display: 'Two' },
  // //         ],
  // //         label: 'Plan type',
  // //         placeholder: 'Enter Plan type'
  // //     }
  // // },
  // {
  //     name: 'insurance[1].form.member_id',
  //     elementType: 'input',
  //     elementConfig: {
  //         type: 'text',
  //         label: 'Member Id',
  //         placeholder: 'Enter Member Id'
  //     }
  // },
];
